import { useContext } from "react";
import { FoldersContext } from "utils/FoldersContext";

export const useFolders = () => {
  const context = useContext(FoldersContext);
  if (context === undefined) {
    throw new Error("useFolders must be used within a FoldersProvider");
  }
  return context;
};
